import { useEffect, useState } from 'react';
import Modal from 'components/core/Modals/Modal/Modal';
import { Button, Typhography } from 'components/core';

interface Props {
  isOpen: boolean;
  count: number;
  onClose: () => void;
  onSubmit: (reason: string) => Promise<void> | void;
  isSubmitting: boolean;
}

const RejectReasonModal = ({ isOpen, count, onClose, onSubmit, isSubmitting }: Props) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      setReason('');
      setError(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = reason.trim();
    if (trimmed.length === 0) {
      setError('Please provide a reason.');
      return;
    }
    await onSubmit(trimmed);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalAdditionalClasses="!w-[520px] items-center justify-center px-6 py-8 flex-col"
    >
      <Typhography
        component="p"
        type="h2"
        color="text-grey-900 mb-4 uppercase"
        additionalClasses="text-center"
      >
        Reject {count} payment{count === 1 ? '' : 's'}
      </Typhography>

      <form onSubmit={handleSubmit} className="space-y-4 w-full">
        <label className="flex flex-col">
          <span className="text-14s text-grey-600 mb-1">Reason (required)</span>
          <textarea
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (error) setError(null);
            }}
            rows={4}
            className="border border-grey-100 rounded-lg px-3 py-2 text-14s focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
            placeholder="Why are these payments being rejected?"
            autoFocus
          />
          {error && <span className="text-red-600 text-12s mt-1">{error}</span>}
        </label>
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
          <Button
            type="button"
            variants="defaultOutlined"
            buttonLabel="Cancel"
            onClick={onClose}
            additionalClasses="px-4 py-2"
          />
          <Button
            type="submit"
            variants="default"
            buttonLabel={isSubmitting ? 'Rejecting…' : 'Reject'}
            isDisabled={isSubmitting}
            additionalClasses="px-4 py-2"
          />
        </div>
      </form>
    </Modal>
  );
};

export default RejectReasonModal;
